<script>
import i18n from "../i18n";
import { authComputed, authMethods } from "@/state/helpers";
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {};
  },
  // mounted() {
  //   this.value = this.languages.find((x) => x.language === i18n.locale);
  //   this.text = this.value.title;
  //   this.flag = this.value.flag;
  // },
  methods: {
    ...authMethods,
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    logoutUser() {
      this.logout().then(() => this.$router.push({ name: "login" }));
    },
  },
  computed: {
    ...authComputed,
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex justify-space-between w-100">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.png" alt height="45" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>
        </div>

        <v-btn
          class="mx-2 my-auto"
          fab
          elevation="0"
          small
          color="primary"
          @click="toggleMenu"
        >
          <v-icon size="20">$vuetify.icons.menu</v-icon>
        </v-btn>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
@media screen and (max-width: 380px) {
  .navbar-brand-box {
    display: inline-block;
    img {
      height: 35px;
    }
  }
}
</style>
